import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import my_logo from '../assets/my_logo.png';


const Navbar = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        let ticking = false;
        const handleScroll = () => {
            if (!ticking) {
                window.requestAnimationFrame(() => {
                    setScrolled(window.scrollY > 20);
                    ticking = false;
                });
                ticking = true;
            }
        };
        window.addEventListener('scroll', handleScroll, { passive: true });
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const navLinks = [
        { name: 'Work', href: '#portfolio' },
        { name: 'About', href: '#about' },
        { name: 'Systems', href: '#systems' },
        { name: 'Contact', href: '#contact' },
    ];

    return (
        <motion.header
            initial={{ y: -50, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.5, ease: "easeOut" }}
            className={`fixed top-4 -translate-x-1/2 z-50 w-[calc(100%-3rem)] md:w-[calc(100%-5rem)] lg:w-[calc(100%-8rem)] max-w-7xl rounded-2xl border transition-all duration-300 ${scrolled
                ? 'bg-charcoal/80 border-white/10 backdrop-blur-md py-3 shadow-gold-glow'
                : 'bg-transparent border-transparent py-5'
                }`}
            style={{ willChange: 'transform, opacity, padding, background-color' }}
        >
            <div className="flex items-center justify-between px-6">
                <div className="flex items-center gap-3">
                    <div className="size-10 overflow-hidden rounded-full border border-gold/30 p-0.5 bg-charcoal">
                        <img
                            src={my_logo}
                            alt="Seif Elshemy"
                            loading="eager"
                            className="w-full h-full object-cover rounded-full"
                        />
                    </div>
                    <span className="text-white text-lg font-bold tracking-tighter hidden sm:block">
                        Seif <span className="text-gradient-gold">Elshemy</span>
                    </span>
                </div>

                <nav className="hidden md:flex items-center gap-8">
                    {navLinks.map((link) => (
                        <a
                            key={link.name}
                            href={link.href}
                            className="text-text-secondary-dark text-sm font-medium hover:text-white transition-colors relative group"
                        >
                            {link.name}
                            <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-gold-gradient transition-all duration-300 group-hover:w-full" />
                        </a>
                    ))}
                    <a
                        href="#contact"
                        className="px-5 py-2 rounded-full bg-gold-gradient text-charcoal-dark text-xs font-bold uppercase tracking-wider hover:scale-105 transition-transform"
                    >
                        Hire Me
                    </a>
                </nav>

                <div className="md:hidden">
                    <button
                        className="text-white p-2 rounded-lg bg-white/5 border border-white/10"
                        onClick={() => setIsMenuOpen(!isMenuOpen)}
                        aria-label="Toggle Menu"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                            <path strokeLinecap="round" strokeLinejoin="round" d={isMenuOpen ? "M6 18L18 6M6 6l12 12" : "M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"} />
                        </svg>
                    </button>
                </div>
            </div>

            <AnimatePresence>
                {isMenuOpen && (
                    <motion.div
                        initial={{ opacity: 0, scale: 0.98, y: -10 }}
                        animate={{ opacity: 1, scale: 1, y: 0 }}
                        exit={{ opacity: 0, scale: 0.98, y: -10 }}
                        className="absolute top-[calc(100%+0.5rem)] left-0 w-full glass-card rounded-2xl p-4 flex flex-col gap-2 md:hidden"
                    >
                        {navLinks.map((link) => (
                            <a
                                key={link.name}
                                className="text-white text-base font-medium p-3 rounded-xl hover:bg-white/5 transition-colors"
                                href={link.href}
                                onClick={() => setIsMenuOpen(false)}
                            >
                                {link.name}
                            </a>
                        ))}
                    </motion.div>
                )}
            </AnimatePresence>
        </motion.header>
    );
};

export default Navbar;
